import {
  CREATE_STATE,
  UPDATE_STATE,
  SET_STEP_VARIANT,
  SET_NEXT_STEP,
  SET_PREV_STEP,
  SET_PERSONAL_DATA,
  SET_IS_ERROR,
  SET_TIME,
  ADD_WAITLIST_INTO_BOOKING_STEPS,
  SET_BOOKING,
  SET_USER_SELECTED_CITY,
  SET_LOCATION,
  SET_SEARCHED_LOCATION,
  SET_CHANGE_LOCATION,
  RESET_SEARCHED_LOCATION,
  SET_ACTIVE_STEP,
  RESET_BOOKING,
  SET_SCHEDULE_STATUS,
  SET_LOCATION_TIME,
} from './types';

const createState = state => ({
  type: CREATE_STATE,
  payload: state,
});

const updateState = state => ({
  type: UPDATE_STATE,
  payload: state,
});

const setStepVariant = (type, variant, data) => ({
  type: SET_STEP_VARIANT,
  payload: { data, variant, type },
});

const setNextStep = nextStep => ({
  type: SET_NEXT_STEP,
  payload: nextStep,
});

const setPrevStep = prevStep => ({
  type: SET_PREV_STEP,
  payload: prevStep,
});

const setIsError = isError => ({
  type: SET_IS_ERROR,
  payload: isError,
});

const setPersonalData = userData => ({
  type: SET_PERSONAL_DATA,
  payload: userData,
});

const setTime = time => ({
  type: SET_TIME,
  payload: time,
});

const setBooking = booking => ({
  type: SET_BOOKING,
  payload: booking,
});

const resetBooking = () => ({
  type: RESET_BOOKING,
});

const addWaitlistIntoBookingSteps = () => ({
  type: ADD_WAITLIST_INTO_BOOKING_STEPS,
});

const setUserSelectedCity = selectedCity => ({
  type: SET_USER_SELECTED_CITY,
  payload: selectedCity,
});

const setLocation = location => ({
  type: SET_LOCATION,
  payload: location,
});

export const setLocationAndTime = (location, time) => ({
  type: SET_LOCATION_TIME,
  payload: { location, time },
});

const setSearchedLocation = location => ({
  type: SET_SEARCHED_LOCATION,
  payload: location,
});

const setChangeLocation = () => ({
  type: SET_CHANGE_LOCATION,
});

const resetSearchedLocation = () => ({
  type: RESET_SEARCHED_LOCATION,
});

const setActiveStep = stepIndex => ({
  type: SET_ACTIVE_STEP,
  payload: stepIndex,
});

const setScheduleStatus = () => ({
  type: SET_SCHEDULE_STATUS,
});

export {
  setNextStep,
  setStepVariant,
  setPrevStep,
  createState,
  updateState,
  setPersonalData,
  setIsError,
  setTime,
  setBooking,
  resetBooking,
  addWaitlistIntoBookingSteps,
  setUserSelectedCity,
  setLocation,
  setSearchedLocation,
  setChangeLocation,
  resetSearchedLocation,
  setActiveStep,
  setScheduleStatus,
};
